import { Attribute } from './attribute';
import { AttributeRegistry } from './attributeRegistry';
export class AlgorithmData extends Attribute {
    clone() {
        throw new Error('Method not implemented.');
    }
    rebind(e) {
        this.entity = e;
        this.bind(AttributeRegistry.AlgorithmDataIndex);
    }
    constructor(entity, data = null) {
        super(entity, AttributeRegistry.AlgorithmDataIndex);
        this.data = data;
    }
    static getAlgData(attrCont) {
        return attrCont.getAttr(AttributeRegistry.AlgorithmDataIndex);
    }
}
//# sourceMappingURL=algorithmData.js.map